
import React, {Component} from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
/* Components */
import KpiContainer from './KpiContainer';
import RegionalPerformanceTab from './RegionalPerformanceTab';
import DelayOverviewTab from './DelayOverviewTab';
import CustomerTab from './CustomerTab';

export default class RightSection extends Component {
    render () {
        var {data, allShipperData, timeSelectorValue, theme} = this.props.rightSectionProps;
        return (
                <div className="col-12 col-sm-9 col-lg-10 right-container ml-auto">
                    <KpiContainer data={data} allShipperData = {allShipperData} timeSelectorValue = {timeSelectorValue}/>
                    <Switch>
                        <Route exact path={`${process.env.PUBLIC_URL}/`} render= {() => <DelayOverviewTab data={data} allShipperData = {allShipperData} timeSelectorValue = {timeSelectorValue} theme={theme}/>} />
                        <Route extact path={`${process.env.PUBLIC_URL}/regional-performance`} render= { () => <RegionalPerformanceTab data={data} allShipperData = {allShipperData} timeSelectorValue = {timeSelectorValue} theme={theme}/>}/>
                        <Route extact path={`${process.env.PUBLIC_URL}/delay-overview`} render= { () => <DelayOverviewTab data={data} allShipperData = {allShipperData} timeSelectorValue = {timeSelectorValue} theme={theme}/>}/>
                        <Route extact path={`${process.env.PUBLIC_URL}/customer-understanding`} render= { () => <CustomerTab data={data} allShipperData = {allShipperData} timeSelectorValue = {timeSelectorValue} theme={theme}/>}/>
                        <Redirect from={`${process.env.PUBLIC_URL}/:id`} to={`${process.env.PUBLIC_URL}/delay-overview`} />
                    </Switch>
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/RightSection.js